import { FAQ } from "./FAQ";
import { HowItWorks } from "./HowItWorks";
import { HelpAFriend } from "./HelpAFriend";
import { Hero } from "./Hero";
import { CustomersSay } from "./CustomersSay";
import type { SectionProps, PreheaderSectionProps } from "./Sections";

export { FAQ, HelpAFriend, Hero, HowItWorks, CustomersSay, SectionProps, PreheaderSectionProps };
